<template>
    <div>
        <v-dialog persistent v-model="dialog" :width="400">
            <v-card tile style="max-height:calc(100vh - 70px)">
                <v-toolbar>
                    <v-toolbar-title class="text-primary">{{ editId ? 'ویرایش رویداد' : 'رویداد جدید' }} <span v-if="day">({{ day }})</span></v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="close" icon>
                        <v-icon color="primary" size="21">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-form ref="form" @submit.prevent="$refs.form?.isValid && $emit('complete', {...data}, editId)" class="py-4 px-5">
                    <datetime-input
                        type="time"
                        label="زمان شروع"
                        clearable
                        @update:modelValue="data.end_date = null"
                        :rules="$validation('required')"
                        v-model="data.start_date"
                    ></datetime-input>
                    <datetime-input
                        type="time"
                        label="زمان پایان"
                        clearable
                        :min="data.start_date"
                        :disabled="!data.start_date"
                        :rules="$validation('required')"
                        v-model="data.end_date"
                    ></datetime-input>
                    <v-text-field
                        label="* عنوان"
                        v-model="data.title"
                        :rules="$validation('required')"
                    ></v-text-field>
                    <v-textarea
                        no-resize
                        label="توضیحات"
                        v-model="data.description"
                        :rules="$validation()"
                    ></v-textarea>
                    <v-row justify="center" align="center">
                        <v-col cols="auto" v-for="(item, index) in ['#E77373', '#F16393', '#AC6BAD', '#70B2E2', '#58C7DA', '#48B8AC', '#8AC44B', '#FDB64E', '#A28A80', '#90A4AF']" :key="index">
                            <div style="border-radius:50%; height:25px; width:25px; cursor:pointer; text-align:center; color:white; padding-top:2px" @click="data.color = item" :style="{backgroundColor: item}"><span v-if="data.color == item">&#10004;</span></div>
                        </v-col>
                    </v-row>
                    <v-btn :loading="buttonLoading" color="success" type="submit" class="mt-5">ثبت اطلاعات</v-btn>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from 'moment-jalaali';
export default {
    data() {
        return {
            dialog: false,
            buttonLoading: false,
            day:null,
            editId: null,
            data: {
                title: null,
                start_date: null,
                end_date: null,
                color: "#E77373",
                description:null
            },
        };
    },
    methods: {
        openAsEdit(data){
            this.dialog = true;
            this.editId = data.id;
            this.data.title = data.title;
            this.data.start_date = data.start_date.format('X');
            this.data.end_date = data.end_date.format('X');
            this.data.description = data.description ?? null;
            this.data.color = data.color;
            this.day = data.start_date.format('jYYYY/jMM/jDD');
        },
        openAsNew(day){
            this.dialog = true;
            this.day = moment(day).format('jYYYY/jMM/jDD');
        },
        close(){
            this.dialog = false;
            this.editId = null;
            this.$emit('close');
            this.data = {title: null, start_date: null, end_date: null, color: '#E77373'};
            if (this.$refs.form)
                this.$refs.form.resetValidation();
        }
    },
};
</script>
